import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SavedSearchComponent } from '../components/saved-search/saved-search.component';
import { SavedSearchSyncDirective } from './directives/saved-search-sync.directive';

@NgModule({
  declarations: [
    SavedSearchComponent,
    SavedSearchSyncDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  exports: [
    SavedSearchComponent,
    SavedSearchSyncDirective
  ]
})
export class SharedModule { }
